namespace SP {
    export enum StackedColumnPeriod {
        ThisWeek = 1,
        LastWeek = 2,
        ThisYear = 4,
        LastYear = 5,
        ThisQuarter = 6,
        LastQuarter = 7,
    }
}